module.exports = __webpack_public_path__ + "img/1.46463db8.svg";